export class SaveOrderNoteInput {
    orderId: number;
    value: string;
    createdById?: number;
}